import { IIntegrationPartner } from "../../../interfaces/interfaces";
import { ipShortNames } from "./emailOtpHelper";
import styles from './OtpStepInfo.module.scss';
import { MdLock as LockIcon } from 'react-icons/md'

type Props = {
    ip: IIntegrationPartner
}

const stepList = (ipName: string = "Blinkit") => {
    return [
        {
            title: <>Log into your <b>{ipName}</b> registered email address.</>
        },
        {
            title: <>Create a filter for emails from <b>{ipName}</b> that contain OTPs.</>
        },
        {
            title: <>Set the filter to securely forward these emails to Merito’s email.</>
        }
    ]
}

const OtpStepInfo = ({ ip }: Props) => {

    const shortIpName = ipShortNames[ip?.companyName] ?? ip?.companyName;

    return (
        <div className={styles.rootContainer}>
            <div className={styles.infoText}>
                To connect {shortIpName}, Merito requires you to enable email forwarding for {shortIpName} OTPs. <br />
                Here’s how it works:
            </div>
            <div className={styles.listInfoContainer}>
                {stepList(shortIpName).map((step, index) => {
                    return (
                        <div className={styles.stepItemContainer}>
                            <div className={styles.stepNumberContainer}>
                                {index + 1}
                            </div>
                            <div className={styles.stepTitle}>
                                {step.title}
                            </div>
                        </div>
                    )
                })}
            </div>
            <div className={styles.bannerContainer}>
                <div className={styles.iconContainer}>
                    <LockIcon />
                </div>
                <div className={styles.textContainer}>
                    Your access stays secure. Merito only uses OTPs to sync data. <br />
                    <b>You can disable forwarding anytime.</b>
                </div>
            </div>
        </div>
    );
}

export default OtpStepInfo;